import { useQuery } from '@pylot-data/hooks/use-query'
import { CUSTOMER_ORDERS } from '../graphql/customerOrders'
import type { RequestInit } from '@vercel/fetch'
import type { SWRConfiguration } from 'swr'
import type { CustomerOrders } from '@pylot-data/pylotschema'

export type OrdersVariableType = {
    pageSize: number
    currentPage: number
}

export type OutputInterface = {
    customer: {
        firstname: string
        lastname: string
        orders: CustomerOrders
    }
}

export const useOrders = (
    variables: OrdersVariableType,
    skip = false,
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
) => {
    const { data, error, isValidating } = useQuery<
        OrdersVariableType,
        OutputInterface
    >(skip ? null : CUSTOMER_ORDERS, variables, swrOptions, fetchOptions)

    const loading = !data && isValidating
    const customer = data?.data?.customer
    const orders = customer?.orders

    return {
        loading,
        error,
        customer,
        orders
    }
}
